import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Star, ChevronDown } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PRODUCT_IMAGES = {
  promescent: 'https://www.promescent.com/cdn/shop/files/20Spray_1024x1024_da9bd637-8d47-4570-86e5-d4a698f59e90.webp?v=1738251213',
  back2game: 'https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/m1ozw06h_%2B%20%281%29.png',
  titan: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/uhp34fvx_4.png',
  vitamel: 'https://customer-assets.emergentagent.com/job_intimate-care-pro-1/artifacts/o2gggziq_3.png',
};

const extraTestimonials = [
  { id: 'ex-1', customer_name: 'אלון מ.', rating: 5, comment: 'המוצר שינה לי את החיים. אחרי שבועיים הרגשתי שיפור משמעותי באנרגיה ובביצועים. ממליץ בחום!', verified: true, product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game },
  { id: 'ex-2', customer_name: 'דני כ.', rating: 5, comment: 'הזמנתי את Back 2 Game ולא האמנתי לתוצאות. המשלוח הגיע מהר ובאריזה דיסקרטית. שירות מעולה.', verified: true, product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game },
  { id: 'ex-3', customer_name: 'רועי ש.', rating: 4, comment: 'מוצר טוב מאוד, לקח כמה ימים עד שהרגשתי את ההשפעה אבל מאז - שיפור ניכר. שווה את ההשקעה.', verified: true, product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent },
  { id: 'ex-4', customer_name: 'עומר ג.', rating: 5, comment: 'כבר חודשיים שאני משתמש ומרגיש כמו בן 20 מחדש. תודה רבה על המוצר האיכותי!', verified: true, product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan },
  { id: 'ex-5', customer_name: 'יגאל ר.', rating: 5, comment: 'הספריי של Promescent עשה פלאים. בת הזוג שלי שמה לב לשינוי כבר בפעם הראשונה.', verified: true, product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent },
  { id: 'ex-6', customer_name: 'שמעון ל.', rating: 4, comment: 'מוצרים איכותיים במחירים הוגנים. המשלוח הגיע תוך יומיים. אשמח להזמין שוב.', verified: true, product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game },
  { id: 'ex-7', customer_name: 'נדב ח.', rating: 5, comment: 'הפעם הראשונה שהזמנתי מוצר כזה אונליין והופתעתי לטובה. האריזה דיסקרטית לחלוטין ואיכות מעולה.', verified: true, product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent },
  { id: 'ex-8', customer_name: 'אריאל ב.', rating: 5, comment: 'המבצע של 1+1 היה משתלם מאוד. שני המוצרים הגיעו במצב מושלם. ממליץ לכולם!', verified: true, product: 'ויטמל', image: PRODUCT_IMAGES.vitamel },
  { id: 'ex-9', customer_name: 'גיא פ.', rating: 4, comment: 'השירות היה מצוין, ענו לי בוואטסאפ תוך דקות. המוצר עצמו טוב, ממתין לראות תוצאות לטווח ארוך.', verified: true, product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan },
  { id: 'ex-10', customer_name: 'תומר א.', rating: 5, comment: 'אחרי שניסיתי מוצרים רבים, זה הדבר היחיד שבאמת עבד. הביטחון העצמי שלי חזר.', verified: true, product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game },
  { id: 'ex-11', customer_name: 'עידן מ.', rating: 5, comment: 'ויטמל עזר לי ולאשתי. אחרי 3 חודשים של שימוש קיבלנו את הבשורה המשמחת! ממליץ.', verified: true, product: 'ויטמל', image: PRODUCT_IMAGES.vitamel },
  { id: 'ex-12', customer_name: 'יוני ד.', rating: 4, comment: 'Back 2 Game עושה את העבודה. שיפור בביצועים אחרי שבוע שימוש. מרוצה מהרכישה.', verified: true, product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game },
  { id: 'ex-13', customer_name: 'מתן ה.', rating: 5, comment: 'הזמנתי חבילה של 3 יחידות ובאמת חסכתי. המוצר מגיע עם הוראות ברורות בעברית.', verified: true, product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent },
  { id: 'ex-14', customer_name: 'אסף ק.', rating: 4, comment: 'בהתחלה הייתי סקפטי אבל החלטתי לנסות. אחרי 3 שבועות אני יכול להגיד שזה עובד. תודה.', verified: true, product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan },
  { id: 'ex-15', customer_name: 'ליאור נ.', rating: 5, comment: 'חבר המליץ לי והוא צדק. איכות מעולה, משלוח מהיר ותוצאות אמיתיות. מה עוד אפשר לבקש?', verified: true, product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game },
  { id: 'ex-16', customer_name: 'בועז צ.', rating: 5, comment: 'שירות לקוחות ברמה הכי גבוהה. שאלתי שאלה בוואטסאפ וקיבלתי תשובה מקצועית תוך דקות.', verified: true, product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent },
  { id: 'ex-17', customer_name: 'אייל ת.', rating: 4, comment: 'מוצר סולידי. לא ציפיתי לנסים אבל ההשפעה חיובית ומורגשת. ארשום עדכון בעוד חודש.', verified: true, product: 'ויטמל', image: PRODUCT_IMAGES.vitamel },
  { id: 'ex-18', customer_name: 'ירון ז.', rating: 5, comment: 'הטיטאן ג\'ל שינה את חווית הזוגיות שלנו. מומלץ בחום, נספג מהר ותחושה מדהימה.', verified: true, product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan },
  { id: 'ex-19', customer_name: 'עמית ע.', rating: 5, comment: 'הפעם השנייה שאני מזמין. כל מוצר שניסיתי מכאן היה מצוין. שירות ואיכות ברמה הגבוהה ביותר.', verified: true, product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game },
  { id: 'ex-20', customer_name: 'דור י.', rating: 4, comment: 'איסוף עצמי מראשון לציון היה סופר נוח. המוצר הגיע ארוז יפה. ממליץ למי שגר באזור.', verified: true, product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent },
  { id: 'ex-21', customer_name: 'איתמר פ.', rating: 5, comment: 'הויטמל עזר לי ולאשתי בדרך להריון. אחרי 3 חודשים של שימוש קיבלנו את הבשורה המשמחת!', verified: true, product: 'ויטמל', image: PRODUCT_IMAGES.vitamel },
  { id: 'ex-22', customer_name: 'רם ס.', rating: 5, comment: 'לקחתי את החבילה המשולבת - Back 2 Game + ספריי. השילוב עושה פלאים. ממליץ בעיניים עצומות.', verified: true, product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game },
  { id: 'ex-23', customer_name: 'נתן ו.', rating: 4, comment: 'מוצר איכותי שעובד. הטעם נוח והתוצאות מורגשות. אזמין שוב בקרוב.', verified: true, product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan },
];

const PRODUCT_LIST = [
  { product: 'תרסיס עיכוב', image: PRODUCT_IMAGES.promescent },
  { product: 'Back 2 Game', image: PRODUCT_IMAGES.back2game },
  { product: "ג'ל עוררות", image: PRODUCT_IMAGES.titan },
  { product: 'ויטמל', image: PRODUCT_IMAGES.vitamel },
];

const INITIAL_COUNT = 6;
const LOAD_MORE_COUNT = 5;

const Recommendations = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visibleCount, setVisibleCount] = useState(INITIAL_COUNT);
  
  useEffect(() => {
    fetchTestimonials();
  }, []);
  
  const fetchTestimonials = async () => {
    try {
      const response = await axios.get(`${API}/testimonials`);
      const dbWithImages = response.data.map((t, i) => ({
        ...t,
        product: t.product || PRODUCT_LIST[i % PRODUCT_LIST.length].product,
        image: t.image || PRODUCT_LIST[i % PRODUCT_LIST.length].image,
      }));
      const combined = [...dbWithImages, ...extraTestimonials];
      setTestimonials(combined);
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      setTestimonials(extraTestimonials);
    } finally {
      setLoading(false);
    }
  };

  const visibleTestimonials = testimonials.slice(0, visibleCount);
  const hasMore = visibleCount < testimonials.length;
  
  if (loading) {
    return (
      <div className="container py-16" data-testid="recommendations-loading">
        <div className="text-center">
          <p className="text-xl text-stone-600">טוען המלצות...</p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="container py-16" data-testid="recommendations-page">
      <div className="text-center mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="recommendations-title">
          מה אומרים הלקוחות
        </h1>
        <p className="text-base md:text-lg text-stone-600">
          המלצות מלקוחות מרוצים שלנו
        </p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="testimonials-grid">
        {visibleTestimonials.map((testimonial) => (
          <div
            key={testimonial.id}
            data-testid={`testimonial-${testimonial.id}`}
            className="bg-white rounded-2xl p-6 border border-stone-100 hover:shadow-lg transition-all duration-300"
          >
            {testimonial.image && (
              <div className="flex flex-col items-center mb-4">
                <div className="w-20 h-24 mb-2 flex items-center justify-center">
                  <img src={testimonial.image} alt={testimonial.product} className="max-h-24 max-w-20 object-contain" />
                </div>
                <p className="font-bold text-[#2C3E2D] text-sm" style={{ fontFamily: 'Heebo, sans-serif' }}>{testimonial.product}</p>
              </div>
            )}
            
            <div className="flex items-center gap-1 mb-1 justify-center">
              {[...Array(testimonial.rating)].map((_, i) => (
                <Star key={i} className="w-4 h-4 fill-[#D97706] text-[#D97706]" />
              ))}
              {[...Array(5 - testimonial.rating)].map((_, i) => (
                <Star key={`e-${i}`} className="w-4 h-4 text-stone-300" />
              ))}
            </div>
            <p className="text-xs text-stone-400 text-center mb-3">מתוך 55</p>
            
            <p className="text-stone-700 mb-6 leading-relaxed text-sm">
              "{testimonial.comment}"
            </p>
            
            <div className="flex items-center justify-between">
              <p className="font-semibold text-[#2C3E2D] text-sm" style={{ fontFamily: 'Heebo, sans-serif' }}>
                {testimonial.customer_name}
              </p>
              {testimonial.verified && (
                <span className="text-xs bg-green-100 text-green-700 px-3 py-1 rounded-full font-medium">
                  קונה מאומת
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      {hasMore && (
        <div className="text-center mt-10">
          <button
            onClick={() => setVisibleCount(prev => prev + LOAD_MORE_COUNT)}
            data-testid="load-more-button"
            className="inline-flex items-center gap-2 h-12 px-8 rounded-full bg-[#2C3E2D] text-white font-bold hover:bg-[#1a2a1b] hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
            style={{ fontFamily: 'Heebo, sans-serif' }}
          >
            הצג עוד המלצות
            <ChevronDown className="w-5 h-5" />
          </button>
        </div>
      )}
      
      {testimonials.length === 0 && (
        <div className="text-center py-16" data-testid="no-testimonials">
          <p className="text-xl text-stone-600">אין המלצות זמינות כרגע</p>
        </div>
      )}
      
      {/* Add Review CTA */}
      <div className="mt-16 bg-[#F5F5F4] rounded-2xl p-12 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-[#2C3E2D] mb-4" style={{ fontFamily: 'Heebo, sans-serif' }}>
          רוצה לשתף את החוויה שלך?
        </h2>
        <p className="text-stone-600 mb-8">
          אנו ישמח לשמוע ממך! צור איתנו קשר בוואטסאפ
        </p>
      </div>
    </div>
  );
};

export default Recommendations;
